import {
  Card,
  CardBody,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
// import ExportData from "components/common/ExportData";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import SalesTable from "components/sales/SalesTable";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import { useState, useEffect, useContext } from "react";
import SalesServices from "services/SalesService";
import SalesDrawer from "components/drawer/SalesDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import Somethingwentwrong from "pages/Somethingwentwrong";
import { SidebarContext } from "context/SidebarContext";
import { FiRefreshCcw } from "react-icons/fi";
import { Tabs, Tab } from "@mui/material";
import sidebar from "routes/sidebar";
import DataWrapper from "./DataWrapper";
import InputAreaDate from "components/form/InputAreaDate";
import LabelArea from "components/form/LabelArea";
import SelectAgent from "components/form/SelectAgent";
import { toast } from "react-toastify";
import useFilter from "hooks/useFilter";
import { useLocation } from "react-router-dom";

const Sales = () => {
  const location = useLocation();
  const { toggleDrawer, isUpdate, setIsUpdate } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tab, setTab] = useState(0);
  const [searchStartDate, setSearchStartDate] = useState(null);
  const [searchEndDate, setSearchEndDate] = useState(null);
  const [selectedAgentId, setSelectedAgentId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [saleStatus, setSaleStatus] = useState(null);

  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const isAdmin = adminInfo?.id === 1;

  const hideView =
    isAdmin ||
    adminInfo?.permission?.some(
      (perm) => perm.id_tab === "sales report" && perm.view === 1,
    );
  const hideEdit =
    isAdmin ||
    adminInfo?.permission?.some(
      (perm) => perm.id_tab === "sales report" && perm.edit === 1,
    );
  const hideAdd =
    isAdmin ||
    adminInfo?.permission?.some(
      (perm) => perm.id_tab === "sales report" && perm.add === 1,
    );
  const hideExport =
    isAdmin ||
    adminInfo?.permission?.some(
      (perm) => perm.id_tab === "sales report" && perm.export === 1,
    );

  const [SalesData, setSalesData] = useState([]);
  const [status, setStatus] = useState("");
  const isDataArray = Array.isArray(SalesData?.data);
  const safeData = isDataArray ? SalesData?.data : [];
  // console.log('safedata',safeData)
  // console.log("data in safedata", safeData);

  const { SalesRef, serviceData, dataTable, handleSubmitSales, currentPage } =
    useFilter(safeData, itemsPerPage);

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formattedDates = {
    start_date: formatDate(searchStartDate),
    end_date: formatDate(searchEndDate),
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlType = params.get("type");
    if (urlType !== null) {
      const parsed = Number(urlType);
      if (!isNaN(parsed) && parsed >= 1 && parsed <= 4) {
        setTab(parsed - 1);
      }
    }

    const start = params.get("start");
    const end = params.get("end");

    if (start && end) {
      const parseDate = (str) => {
        const [dd, mm, yyyy] = str.split("-");
        return new Date(yyyy, mm - 1, dd);
      };

      setSearchStartDate(parseDate(start));
      setSearchEndDate(parseDate(end));
    }

    const status = params.get("status");

    if (status === "partial") {
      setSaleStatus("partial");
    } else {
      setSaleStatus(null);
    }
  }, [location.search]);

  const fetchSales = async () => {
    setLoading(true);
    setError(null);
    try {
      const payload = {
        type: tab + 1,
        agent_id: selectedAgentId || null,
        partial_status: saleStatus,
        //partial_status:partial
      };
      // console.log("partial status:",payload)

      const start_date = formattedDates.start_date;
      const end_date = formattedDates.end_date;
      if (start_date) payload.start_date = start_date;
      if (end_date) payload.end_date = end_date;
      const response = await SalesServices.getAllSales(payload);
      // console.log("all sales from response--", response);
      if (response.status) {
        setSalesData(response);
        setStatus(response.status);
      } else {
        setSalesData([]);
        setStatus(false);
        setError("No sales data found");
        toast.error("No sales data found");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch sales";
      console.error("Error fetching Sales data:", errorMessage);
      setError(errorMessage);
      toast.error(`Error fetching Sales data: ${errorMessage}`);
      setStatus(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const hasDateParams = new URLSearchParams(location.search).has("start");
    if (!isUpdate && hasDateParams && !searchStartDate && !searchEndDate) {
      // console.log("Skipping initial fetch — waiting for URL date parsing");
      return;
    }
    fetchSales();
    setIsUpdate(false);
  }, [tab, isUpdate, searchStartDate, searchEndDate, saleStatus]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
    setSearchStartDate(null);
    setSearchEndDate(null);
    setSelectedAgentId(null);
    setIsUpdate(true);
  };

  const handleSearch = () => {
    setIsUpdate(true);
  };

  const handleRefresh = () => {
    // Clear all filter data and reset states
    setSearchStartDate(null);
    setSearchEndDate(null);
    setSelectedAgentId("");
    setSalesData([]); // Clear the sales data immediately
    setStatus(""); // Reset status
    setError(null); // Clear any error
    setIsUpdate(true); // Trigger a fresh fetch
  };

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  // GST/TDS/receivable/balance are computed once, server-side (see
  // computeGstTds in salesModel.js) and returned on each row as
  // gst_amount/tds_amount/receivable_amt/balance_amt — export renders those
  // directly instead of recomputing tax math here, so the export can never
  // disagree with the report table or what's actually stored.
  function transformSalesDataForExport(data = []) {
    const round = (val) => Math.round(parseFloat(val || 0) * 100) / 100;

    const computedSales = data.map((item) => {
      const totalReceived = Array.isArray(item.sales_records)
        ? item.sales_records.reduce(
            (sum, rec) => sum + parseFloat(rec.received_amt || 0),
            0,
          )
        : parseFloat(item.received_amount || 0);

      return {
        ...item,
        gst_amount: Number(item.gst_amount || 0),
        tds_amount: Number(item.tds_amount || 0),
        receivable_amt: Number(item.receivable_amt || 0),
        received_amt: totalReceived,
        balance_amt: Number(item.balance_amt || 0),
        basic_fare: Number(item.basic_fare || 0),
      };
    });

    // Group by Agent Name (no sorting, just natural order)
    const grouped = {};
    const orderedAgents = [];
    computedSales.forEach((item) => {
      const agent = item.agentname || "Unknown Agent";
      if (!grouped[agent]) {
        grouped[agent] = [];
        orderedAgents.push(agent); // preserve appearance order
      }
      grouped[agent].push(item);
    });

    // Calculate overall totals
    const totals = computedSales.reduce(
      (acc, item) => {
        acc.selling_price += Number(item.selling_price || 0);
        acc.taxable_value += item.basic_fare;
        acc.gst += item.gst_amount;
        acc.tds += item.tds_amount;
        acc.receivable_amt += item.receivable_amt;
        acc.received_amt += Number(item.received_amt || 0);
        acc.balance_amt += item.balance_amt;
        return acc;
      },
      {
        selling_price: 0,
        taxable_value: 0,
        gst: 0,
        tds: 0,
        receivable_amt: 0,
        received_amt: 0,
        balance_amt: 0,
      },
    );

    // Prepare formatted export data
    const formattedData = [];
    let serial = 1;

    orderedAgents.forEach((agentName) => {
      grouped[agentName].forEach((item) => {
        // const receivedDates =
        //   Array.isArray(item.sales_records) && item.sales_records.length > 0
        //     ? item.sales_records.map((rec) => rec.received_date || "-").join("\n")
        //     : item.received_date || "-";

        // const receivedAmts =
        //   Array.isArray(item.sales_records) && item.sales_records.length > 0
        //     ? item.sales_records.map((rec) => round(rec.received_amt || 0)).join("\n")
        //     : round(item.received_amt || 0);

        // const remarks =
        //   Array.isArray(item.sales_records) && item.sales_records.length > 0
        //     ? item.sales_records.map((rec) => rec.remark || "-").join("\n")
        //     : item.remark || "-";

        const receivedDates =
          Array.isArray(item.sales_records) && item.sales_records.length > 0
            ? item.sales_records
                .map((rec) => rec.received_date || "-")
                .join(", ")
            : item.received_date || "-";

        const receivedAmts =
          Array.isArray(item.sales_records) && item.sales_records.length > 0
            ? item.sales_records
                .map((rec) => round(rec.received_amt || 0))
                .join(", ")
            : round(item.received_amt || 0);

        const remarks =
          Array.isArray(item.sales_records) && item.sales_records.length > 0
            ? item.sales_records.map((rec) => rec.remark || "-").join(", ")
            : item.remark || "-";

        formattedData.push({
          "S.No.": serial++,
          "Agent Name": agentName,
          Client_ref: item.client_ref || "-",
          Start_date: item.start_date || "-",
          End_date: item.end_date || "-",
          "Client Name": item.client_name || "-",
          "Arrival Date": item.start_date || "-",
          Arrival: item.arrival || "-",
          Departure: item.departure || "-",
          Selling_price: round(item.selling_price || 0),
          "Taxable Value": item.basic_fare.toFixed(2),
          GST: item.gst_amount.toFixed(2),
          TDS: item.tds_amount.toFixed(2),
          Addon: item.addon_rate?.toFixed(2) || 0,
          Receivable_amt: Math.round(item.receivable_amt),
          "Received Date": receivedDates,
          "Received Amt": receivedAmts,

          "Balance Amount": item.balance_amt.toFixed(2),
          Remarks: remarks,
        });
      });
    });

    // final total row
    formattedData.push({
      "S.No.": "",
      "Agent Name": "",
      Client_ref: "",
      Start_date: "",
      End_date: "",
      "Client Name": "",
      "Arrival Date": "",
      Departure: "TOTAL",
      Selling_price: round(totals.selling_price),
      "Taxable Value": totals.taxable_value.toFixed(2),
      GST: round(totals.gst),
      TDS: round(totals.tds),
      Receivable_amt: round(totals.receivable_amt),
      "Received Date": "",
      "Received Amt": round(totals.received_amt),
      "Balance Amount": round(totals.balance_amt),
      Remarks: "",
    });

    return formattedData;
  }

  const getTabName = () => {
    if (tab === 0) return "Unpaid";
    if (tab === 1) return "Paid";
    if (tab === 2) return "All";
    return "";
  };

  return (
    <>
      {hideView && (
        <>
          <PageTitle sidebar={sidebar().sidebar} />
          <DeleteModal id={serviceId} title={title} />
          <MainDrawer>
            <SalesDrawer id={serviceId} />
          </MainDrawer>

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
            <CardBody>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <LabelArea label="Start Date" />
                    <div className="w-50">
                      <InputAreaDate
                        value={searchStartDate}
                        onChange={(date) => setSearchStartDate(date)}
                      />
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <LabelArea label="End Date" />
                    <div className="w-50">
                      <InputAreaDate
                        min={searchStartDate}
                        value={searchEndDate}
                        onChange={(date) => setSearchEndDate(date)}
                      />
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <LabelArea label="Agent" />
                    <div className="w-50">
                      <SelectAgent
                        label="Agent Name"
                        name="agent_id"
                        value={selectedAgentId || ""}
                        onChange={(e) => {
                          // console.log('SelectAgent onChange:', e.target.value);
                          setSelectedAgentId(e.target.value);
                        }}
                        type="text"
                        placeholder="Agent Name"
                        register={() => () => ({})}
                      />
                    </div>
                  </div>
                </div>
                <Button className="rounded-md h-10 px-8" onClick={handleSearch}>
                  Search
                </Button>
                <FiRefreshCcw onClick={handleRefresh} cursor="pointer" />
              </div>
              <div className="flex justify-between items-end flex-wrap gap-3 w-full pt-4 px-2">
                <div className="flex items-end gap-3 flex-wrap">
                  <div className="flex items-center gap-2">
                    <input
                      ref={SalesRef}
                      type="text"
                      placeholder="Quick Search"
                      className="p-2 border rounded w-64"
                      onChange={handleSubmitSales}
                    />
                    <Button onClick={handleSubmitSales}>Search</Button>
                  </div>
                </div>
                {hideExport && (
                  <div className="pr-2">
                    <ExportDataXlsx
                      title="Sales"
                      exportDataXlsx={transformSalesDataForExport(serviceData)}
                      fileNames={`Sales_${getTabName()}`}
                      startDate={searchStartDate}
                      endDate={searchEndDate}
                    />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>

          <Tabs
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{ style: { backgroundColor: "#057a55" } }}
            sx={{ "& .MuiTab-root": { textTransform: "capitalize" } }}
          >
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55" } }}
              label="Unpaid"
            />
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55" } }}
              label="Paid"
            />
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55" } }}
              label="All"
            />
          </Tabs>

          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData.length > 0 ? (
              <TableContainer
                className="mb-4"
                style={{
                  maxHeight: "65vh",
                  overflow: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                <Table>
                  <TableHeader className="custom-table-header capitalize sticky top-0 z-10">
                    <tr>
                      <TableCell className="text-center">Sl.No.</TableCell>
                      <TableCell className="text-center">
                        Agent ID / Booking ID
                      </TableCell>
                      <TableCell className="text-center">Agent Name</TableCell>
                      <TableCell className="text-center">Client Name</TableCell>
                      <TableCell className="text-center">
                        Arrival / Departure
                      </TableCell>
                      <TableCell className="text-center">Travel Date</TableCell>
                      <TableCell className="text-center">
                        <div>Transport Selling</div>
                        <div className="text-sm text-gray-600">D=(A+B+c)</div>
                      </TableCell>
                      <TableCell className="text-center">
                        <div>Basic Fare</div>
                        <div className="text-sm text-gray-600">A=(D-B+C)</div>
                      </TableCell>

                      <TableCell className="text-center">
                        <div>GST</div>
                        <div className="text-sm text-gray-600">B</div>
                      </TableCell>

                      <TableCell className="text-center">
                        <div>Addon/activity</div>
                        <div className="text-sm text-gray-600">C</div>
                      </TableCell>

                      <TableCell className="text-center">
                        Cancellation Charges
                      </TableCell>

                      <TableCell className="text-center">
                        <div>TDS</div>
                        <div className="text-sm text-gray-600">
                          E=(A% 1 or 2)
                        </div>
                      </TableCell>
                      <TableCell className="text-center">
                        <div>Recievable Amt</div>
                        <div className="text-sm text-gray-600">F=(D-E)</div>
                      </TableCell>
                      {/* <TableCell className="text-center">add amt</TableCell> */}
                      <TableCell className="text-center">
                        Received Amt
                      </TableCell>
                      <TableCell className="text-center">
                        Received Date
                      </TableCell>
                      <TableCell className="text-center">
                        Payment Type
                      </TableCell>
                      {/* <TableCell className="text-center">edit</TableCell> */}
                      <TableCell className="text-center">Balance Amt</TableCell>
                      <TableCell className="text-center">Remark</TableCell>
                      <TableCell className="text-center">Status</TableCell>

                      <TableCell className="text-center">
                        Cancellation Reason
                      </TableCell>
                      <TableCell className="text-center">Actions</TableCell>
                    </tr>
                  </TableHeader>
                  {/* {console.log(dataTable)} */}
                  <SalesTable
                    Sales={dataTable}
                    perpage={itemsPerPage}
                    currentPage={currentPage}
                    tab={tab}
                    hideEdit={hideEdit}
                    hideAdd={hideAdd}
                    fetchSales={fetchSales}
                  />
                </Table>
              </TableContainer>
            ) : (
              <>
                {status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Sales." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default Sales;
